import Vue from 'vue'
import App from './App.vue'
// 引入ELEMENT
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css'


import './assets/iconfont/iconfont.css'

import './assets/manage.css'

// 引入 wangEditor 富文本编辑器（全局注册 WangEditor / WangToolbar 组件及自定义菜单）
import './plugins/wangEditor'

// 引入全局配置
import config from '../src/utils/config'
Vue.prototype.$config = config.data

// 引入FILTER
import filters from '../src/utils/filter'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

import router from './router'
import store from './store'
router.beforeEach((to, from, next) => {
    document.title = (to.meta.title ? to.meta.title + '-' : '') + '伊颂婚恋管理平台'
    next()
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
